import { create } from 'zustand';

/**
 * A notification targeted a different (but linked) tenant. We stash the intended
 * destination here; <TenantSwitchPrompt /> renders the confirm sheet, performs the
 * SSO tenant switch on accept, then routes to `path`.
 */
export interface PendingTenantSwitch {
  tenantId: string;
  tenantName: string;
  path: string;
}

interface TenantSwitchPromptState {
  pending: PendingTenantSwitch | null;
  request: (req: PendingTenantSwitch) => void;
  clear: () => void;
}

export const useTenantSwitchPrompt = create<TenantSwitchPromptState>((set) => ({
  pending: null,
  request: (req) => set({ pending: req }),
  clear: () => set({ pending: null }),
}));
